export default {
    pageTitle: 'Chat',
    conversationList: {
        intelligentFilterDisabled: 'Filtre intelligent inactif',
        intelligentFilterEnabled: 'Filtre intelligent actif',
        noResults: 'Aucun résultat.',
        showActive: 'Afficher conversations actives',
        showArchive: 'Afficher conversations archivées',
        showNonActionnable: 'Les conversations composées uniquement de confirmations de rendez-vous, de messages de campagnes et des mots-clés "OUI", "NON" et "STOP" ne seront pas affichées',
        hideNonActionnable: 'Toutes les conversations seront affichées, incluant celles qui contiennent uniquement des confirmations de rendez-vous, des messages de campagnes ou les mots-clés "OUI", "NON" et "STOP"',
        newConversation: 'Nouvelle conversation',
        filter: 'Filtres',
        seeConversationsOf: 'Voir les conversations de...',
    },
    conversation: {
        youAsSender: 'Vous',
        picture: '[Photo]',
    },
    newConversation: {
        header: 'Nouvelle conversation',
        selectContact: 'Sélectionnez un contact',
        errors: {
            limitExceeded: 'Vous avez atteint la limite de conversations séparées avec ce contact.',
            conversationAlreadyExist: 'Vous avez déjà amorcé une conversation avec ce contact.',
            failedToRetrieveContact: 'La recherche du contact a échouée.',
            noValidPhoneAvailable: 'Aucun numéro de téléphone valide disponible.',
            invalidNumberSubtitle: 'Numéro invalide',
            invalidNumberMessage: 'Le contact doit être lié à au moins un numéro de téléphone valide afin de créer une conversation.',
        },
    },
    message: {
        notDelivered: 'Non livré',
        notDeliveredNoAccess: 'Non autorisé',
        notDeliveredUnreachable: 'Le numéro est un téléphone fixe ou injoignable',
        notDeliveredUnreachableWithRetry: 'Le numéro n\'a pu être rejoint. Cliquez pour réessayer.',
        error: "Une erreur s'est produite. Cliquez pour réessayer.",
        errorNoAccess: "Vous n'êtes pas autorisé à envoyer des messages à ce contact.",
    },
    messageList: {
        isUnreachable: 'Le numéro ({number}) est un téléphone fixe ou injoignable',
        changePhoneBeforeInteract: 'Vous devez choisir ou ajouter un numéro valide pour continuer',
        contactsSelected: 'contacts sélectionnés',
        conversationArchived: 'Conversation archivée',
        restoreBeforeInteract: 'Vous devez restaurer cette conversation avant de pouvoir interagir avec cette personne à nouveau.',
        numberUnavailable: 'Numéro de téléphone indisponible',
        useNewNumber: 'Le numéro utilisé ({number}) pour contacter le client n\'est plus disponible.',
        numberChange: 'Le numéro du contact a été changé à :<br>' +
            '{newNumber} (de {oldNumber})',
        assignNewNumberWithTemplate: 'Nouveau numéro',
        numberUnavailablePolestar: 'SMS Number temporarily changed',
        useNewNumberPolestar: 'Due to new regulatory practices in the United States, you must use a new number to message this customer.\n\n' +
            'We’ve automatically inserted a message template to make it easier to explain this change to your customer.\n\n' +
            'To learn more,  <a target="_blank" href="https://www.youtube.com/watch?v=OtSSJjXHaao">watch this video</a>.',
        assignNewNumberWithTemplatePolestar: 'Respond with template',
        numberChangeTemplate: 'Hello {clientFullName}, this is {userFullName} from {dealerName}! Last time we spoke ' +
            'I was using {originalNumer}. Due to some regulatory changes, I’ll be using this number from now on. ' +
            'Feel free to reach out to me here at any time.',
        doIt: 'Voulez-vous le faire?',
        restore: 'Restaurer',
        appointmentTitle: 'Rendez-vous',
        paid: 'Payé',
        paymentTitle: 'Paiement',
        received: 'Reçu',
        statusConfirmed: 'Confirmé',
        byEmail: 'par courriel',
        bySms: 'par SMS',
        statusCanceled: 'Annulé',
        statusUnknown: 'Non Confirmé',
        readOnly: 'Lecture seulement',
        notInConversation: 'Vous ne faites pas partie de cette conversation. Pour communiquer avec ce client, veuillez amorcer une nouvelle conversation.',
        consentExpiration: "Fin d'adhésion",
        consentConfirmed: 'Adhésion confirmée',
        consentLimitDate: 'Adhésion expirant le {date}',
        userConsentMoreInfo: 'Sans le consentement explicite du client, la Loi canadienne anti-pourriel vous empêchent de communiquer avec lui de façon électronique depuis le {date}.',
        userUnsubscribed: 'Contact désabonné',
        userMustResubscribe: 'Le contact doit se réabonner aux communications par SMS pour que vous puissiez lui écrire. Il lui suffit d\'envoyer le message "UNSTOP" au {number}.',
    },
    messageInput: {
        enterMessage: 'Saisissez un message...',
        sendingFailed: 'Une erreur s\'est produite lors de l\'envoi du SMS. Veuillez réessayer.',
        manage: 'Gérer...',
        uploadFile: 'Téléverser un fichier',
        providerPhoneUnavailableTooltip: 'Impossible d\'envoyer le message, aucun numéro de téléphone de fournisseur disponible, veuillez contacter le support',
        insertTemplate: 'Insérer un message prédéfini',
        addEmoji: 'Emojis',
        templatesModal: {
            header: 'Insérer un message prédéfini',
            insert: 'Insérer',
        },
        tooltipCount: 'Nombre de caractères / Nombre de SMS',
    },
    messageTemplate: {
        template: 'Message prédéfini',
        builder: 'Constructeur de message',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression de message prédéfini',
            message: 'Voulez-vous vraiment supprimer ce message prédéfini?',
        },
        newTemplate: 'Nouveau message prédéfini',
        noTemplate: 'Aucun message prédéfini',
        noSearchMatch: 'Aucun résultat ne correspond à votre recherche',
        templatesList: 'Messages prédéfinis',
        headerName: 'Nom',
        headerContent: 'Message',
        headerCategory: 'Catégorie',
        close: 'Fermer',
        category: 'Catégorie du message prédéfini',
        name: 'Nom du message prédéfini',
        placeholdersList: 'Liste des attributs',
        subject: 'Sujet (courriel seulement)',
    },
    messageTemplateModal: {
        successes: {
            created: 'Message prédéfini créé avec succès.',
            updated: 'Message prédéfini modifié avec succès.',
            deleted: 'Message prédéfini supprimé avec succès.',
        },
        errors: {
            creating: 'Erreur lors de la création du message prédéfini.',
            updating: 'Erreur lors de la modification du message prédéfini.',
            deleting: 'Erreur lors de la suppression du message prédéfini.',
        },
    },
    templateCategory: {
        category: 'Catégorie de messages prédéfinis',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression de catégorie de messages prédéfinis',
            message: 'Voulez-vous vraiment supprimer cette catégorie de messages prédéfinis?<br>Les messages prédéfinis associés seront également supprimés.',
        },
        noCategory: 'Aucune catégorie',
        categoriesList: 'Catégories de messages prédéfinis',
        headerName: 'Nom',
        close: 'Fermer',
        name: 'Nom',
    },
    templateCategoryModal: {
        successes: {
            created: 'Catégorie créé avec succès.',
            updated: 'Catégorie modifié avec succès.',
            deleted: 'Catégorie supprimé avec succès.',
        },
        errors: {
            creating: 'Erreur lors de la création de la catégorie.',
            updating: 'Erreur lors de la modification de la catégorie.',
            deleting: 'Erreur lors de la suppression de la catégorie.',
        },
    },
    infoBar: {
        activateConversation: 'Restaurer la conversation',
        deactivateConversation: 'Archiver la conversation',
        accessClientCard: 'Accéder à la fiche client du CRM',
        addAppointment: 'Ajouter un rendez-vous',
        contactInfos: 'Ouvrir la fiche du contact',
        createPayment: 'Créer un paiement',
    },
};
